import ImageWithSkeleton from './ComponentsPage/ImageWithSkeleton';

export default function HeroSection() {
  return (
    <div className="relative overflow-hidden">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pt-10 sm:pt-60 lg:pt-32 pb-12 sm:pb-20">
        <div className="mx-auto max-w-2xl lg:max-w-none lg:flex lg:items-center lg:gap-12">
          {/* Copy */}
          <div className="relative w-full lg:max-w-xl lg:shrink-0 xl:max-w-2xl">
            <h1 className="text-2xl font-bold tracking-tight text-pretty text-primary-main">
              About KiN Space
            </h1>
            <p className="mt-4 text-base text-pretty text-kin-text">
              KiN (Kids Nusantara) is an ode to Nusantara, where Indonesia’s rich culture inspires
              the space, activity, and the brand’s roots. Our mission is to captivate young minds
              and nurture well-being through Indonesian art and culture.
              <br />
              <br />
              We blend education with imagination, offering a gateway to explore the wonders of
              Nusantara. KiN Space is in SCBD Park, Jakarta. This family space offers a unique blend
              of exhibition, play, learning, gallery, retail, and a cozy cafe.
            </p>
          </div>

          <div className="mt-10 lg:mt-0 lg:flex-1">
            <div className="grid grid-cols-3 gap-3 md:gap-3 lg:grid-cols-2 xl:grid-cols-3 lg:gap-3 lg:pl-0">
              {/* Col A */}
              <div className="col-span-1 space-y-3 lg:hidden xl:block lg:pt-0 xl:pt-16">
                <ImageWithSkeleton
                  src="kin/assest/about/asset_about_13.webp"
                  alt="Kids activity A1"
                />
                <ImageWithSkeleton
                  src="kin/assest/about/asset_about_11.webp"
                  alt="Kids activity A2"
                />
              </div>

              {/* Col B */}
              <div className="col-span-1 flex-none space-y-3 lg:pt-36">
                <ImageWithSkeleton
                  src="kin/assest/about/asset_about_6.webp"
                  alt="Kids activity B1"
                />
                <ImageWithSkeleton
                  src="kin/assest/about/asset_about_4.webp"
                  alt="Kids activity B2"
                />
              </div>

              {/* Col C */}
              <div className="col-span-1 flex-none space-y-3 lg:pt-0">
                <ImageWithSkeleton
                  src="kin/assest/about/asset_about_9.webp"
                  alt="Kids activity C1"
                />
                <ImageWithSkeleton
                  src="kin/assest/about/asset_about_15.webp"
                  alt="Kids activity C2"
                />
              </div>
            </div>
          </div>
          {/* /Mosaic */}
        </div>
      </div>
    </div>
  );
}
